module.exports = __webpack_public_path__ + "static/media/Storage-how-it-works-3.a6e8ed34.jpg";